import React, { useEffect, useState } from 'react'
import ApiRequest from '../Common/restservice';
import { copyToClipboard, errorToast, successToast } from '../Common/showtoast';
import { useNavigate } from 'react-router-dom';

function Deposit() {
    const [qrText, setQrText] = useState("");
    const [tableData, setTableData] = useState([]);
    const navigate = useNavigate();
    useEffect(() => {
        GetDepositHistory();
        getDepositDetails();
    }, [])
    const getDepositDetails = async () => {
        let res = await ApiRequest("deposit.asp", "GET", null, { Authorization: localStorage.getItem("token") });
        if (res.status === "error") {
            errorToast(res.message);
            if (res.message === "Session Expired") {
                localStorage.clear();
                navigate("/");
            }
            return;
        }
        setQrText(res.WalletAddress);
    }
    const GetDepositHistory = async () => {
        let res = await ApiRequest("ewallet_request_report.asp", "GET", null, { Authorization: localStorage.getItem("token") });
        console.log(res);
        if (res.status === "error" || res.status === "Error") {
            if (res.message === "Session Expired") {
                errorToast(res.message);
                localStorage.clear();
                navigate("/login");
            }
            return;
        }
        setTableData(res.items);
    }
    return (
        <section className='content'>
            <div className="row">
                <div className="col-xl-12 col-lg-12 col-md-12 col-xm-12">
                    <div className="card overflow-hidden dash1-card border-0 ">
                        <div className="card-body text-center">
                            <h2 style={{marginTop:20,marginBottom:20}}>Please Deposit Your USDT (BEP20)</h2>
                            <img
                                style={{ border: "1px solid", borderRadius: 5,maxHeight:200,maxWidth:200 }}
                                src={`https://qrcode.tec-it.com/API/QRCode?data=${qrText}`}
                                alt=''
                            />
                            <br />
                            <h6 className="text-fade" style={{marginTop:20,marginBottom:20}}>{qrText}</h6>
                            <button style={{marginTop:20,marginBottom:20}} className="btn btn-primary" onClick={(e) => {
                                copyToClipboard(qrText);
                            }}>Copy</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-xl-12 col-lg-12 col-md-12">
                    <div className="card">
                        <div className="card-header">
                            <h3
                                className="card-title text-color-3"
                                style={{ fontWeight: "200", fontSize: "22px" }}
                            >
                                Deposit History
                            </h3>
                        </div>
                        <div className="card-body">
                            <div className="table-responsive">
                                <table
                                    className="table table-vcenter text-nowrap mb-0 table-striped table-bordered border-top"
                                    style={{ textAlign: "center" }}
                                >
                                    <thead>
                                        <tr>
                                            <th>S.No</th>
                                            <th>Date</th>
                                            <th>Deposited</th>
                                            <th>Trasnsation ID</th>
                                            <th>Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {tableData.length <= 0 ? (
                                            <tr>
                                                <td colSpan="5">No Details Found</td>
                                            </tr>
                                        ) : (
                                            tableData.map((item, index) => (
                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td>{item.Date}</td>
                                                    <td>{item.Deposited}</td>
                                                    <td>{item.TrasnsationID}</td>
                                                    <td>{item.Status}</td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Deposit
